import {
	addLoadingScreen,
	addModalWindow,
	addToast,
	EXTRA_SCREEN,
	PLAY_SCREEN,
	removeLoadingScreen,
	resetScreenAfterLogout,
	SETTINGS_SCREEN
} from './duck-screen';
import {
	fetchGameTypeLevelsProperties,
	fetchGameTypeUserLevels,
	initializeUserCloudFunction,
	resetGameAfterLogout,
	resetUserStateAfterLogin,
	saveAllUserLevels,
	saveAllUserRiddles,
	saveGameTypeUserLevel,
	transformLevelListToLevelGameTypeObject
} from './duck-game';
import {
	CLOUD_FUNCTION_ROOT_COLLECTION,
	CLOUD_FUNCTION_ROOT_DOCUMENT,
	firebase,
	fsVersion,
	functions,
} from "../firestore";
import LOGIN_EMAIL_ACTIONS from "../constants/LOGIN_EMAIL_ACTIONS";
import authErrorBuilder from '../helpers/auth-error-builder'
import {getTranslation} from "../helpers/get-translation";
import {
	addReducerParametersToError,
	CRASH_CLOUD_FUNCTION_ERROR,
	CRASH_ERROR,
	isErrorFromCloudFunction,
	NON_FATAL_ERROR,
	parseCloudFunctionErrorAndUnsetCode,
	sendError
} from "../middleware/middleware-error-handler";
import {setActivePlayerStats} from "./duck-ranking";
import {infoModal, TYPE_WHEEL} from "../helpers/modal-builder";
import {getImageWithoutCache} from "../helpers/image-cache";

export const LOGIN_USER = "LOGIN_USER";
export const UPDATE_USER_NAME = "UPDATE_USER_NAME";
export const UPDATE_USER_AVATAR = "UPDATE_USER_AVATAR";
export const SAVE_USER_INFO_AND_SETTINGS = "SAVE_USER_INFO_AND_SETTINGS";
export const SAVE_USER_RANKING = "SAVE_USER_RANKING";
export const SAVE_USER_SETTINGS = "SAVE_USER_SETTINGS";
export const TOGGLE_SOUND = "TOGGLE_SOUND";
export const TOGGLE_VIBRATION = "TOGGLE_VIBRATION";
export const SETTINGS_SAVED = "SETTINGS_SAVED";
export const SETTINGS_CHANGED = "SETTINGS_CHANGED";
export const REPLACE_USER_STATS = "REPLACE_USER_STATS";
export const UPDATE_USER_STATS_AFTER_WRONG_GUESS = "UPDATE_USER_STATS_AFTER_WRONG_GUESS";
export const RESET_USER_AFTER_LOGOUT = "RESET_USER_AFTER_LOGOUT";
export const CHANGE_LOGIN_ACTION = "CHANGE_LOGIN_ACTION";
export const SET_IS_FIXING_DATABASE = "SET_IS_FIXING_DATABASE";
export const SET_IS_USER_ANONYMOUS_FLAG = "SET_IS_USER_ANONYMOUS_FLAG";
export const SET_DID_USER_DELETE_ACCOUNT = "SET_DID_USER_DELETE_ACCOUNT";
export const UPDATE_HINT_COUNT = "UPDATE_HINT_COUNT";
export const UPDATE_LAST_SPIN_OF_WHEEL = "UPDATE_LAST_SPIN_OF_WHEEL";
// export const UPDATE_USER_AVATAR = "UPDATE_USER_AVATAR";


export const FS_LOGIN_FACEBOOK = 0;
export const FS_LOGIN_GOOGLE = 1;

/**
 * Funkcja wołana po zmianie auth, lub po pomyślnym zalogowaniu
 * @param user
 */
export function initializeUserState(user){
	return (dispatch, getState) => {
		const currentState = getState();
		if((!currentState.userReducer.uid || currentState.userReducer.uid !== user.uid)
			&& !currentState.gameReducer.isDatabaseResetting){

			let uid;

			if(user.user){
				uid = user.user.uid
			} else {
				uid = user.uid
			}

			dispatch(loginUser(uid));

			dispatch(fetchUserInfo(uid, user.isAnonymous));
			dispatch(fetchUserStats(uid, user.isAnonymous));
			dispatch(fetchGameTypeUserLevels());
		}


	}
}

/**
 * Funkcja używana w przypadku wylogowania się, lub usunięcia konta
 * Ustawia ona defaultowe stany w odpowiednich reducerach
 */
export function fsLogoutUser() {
	return dispatch => {
		// debugger;

		firebase.auth().signOut().then(() => {
			dispatch(resetGameAfterLogout());
			dispatch(resetScreenAfterLogout());
			dispatch(resetUserAfterLogout());
		}).catch(error => {
			console.log(error);
			debugger;
			// throw new Error("Nie udalo sie wylogowac")
			dispatch(sendError(error, CRASH_ERROR, 'error_could_not_log_out'));
		});
	}
}


/**
 * Funkcja używana przy logowaniu mailowym
 *
 * @param email
 * @param password
 * @param errorCallback - służy do pokazania błędu, np adres email nie istnieje
 * @param successCallback - służy do cofnięcia ekranu na stronę główną
 */
export function fsLoginEmail(email, password, errorCallback, successCallback) {
	return dispatch => {
		// debugger;
		firebase.auth().useDeviceLanguage();
		firebase.auth().signInWithEmailAndPassword(email, password).then((user) => {
			successCallback();
			console.log('zalogowany');
			// debugger;
			if(user.user){
				user = user.user;
			}

			dispatch(resetUserStateAfterLogin());

			dispatch(fetchGameTypeLevelsProperties());

			dispatch(initializeUserState(user));

		}).catch(error => {
			console.log(error);

			const errorMessage = getAuthErrorMessage(error.code);

			if(!errorMessage){
				debugger;
				dispatch(sendError(error, CRASH_ERROR, 'error_could_not_log_in'));
				errorCallback()
			} else {
				errorCallback(errorMessage)
			}

			debugger;
		})

	}
}

/**
 *  Funkcja używana na ekranie ustawień oraz logowania mailowego
 *  W przypadku jeśli użytkownik nie jest zalogowany mailowo tylko przy użyciu socialami,
 *  funkcja resetuje jego hasło, ale tylko mailowego providera, czyli może się logować mailem i socialem
 *
 * @param email - mail na który ma zostać wysłany link z resetem hasła
 * @param errorCallback - w przypadku jak firebase zwróci błąd wywołany jest ten callback, używane na ekranie logowanie mailowego
 * @param successCallback - callback po pomyślnym wysłaniu maila, używany na ekranie logowania mailowego
 *
 */
export function fsResetEmailPassword(email, errorCallback=()=>null, successCallback=()=>null) {
	return dispatch => {
		debugger;
		firebase.auth().useDeviceLanguage();
		// dispatch(addLoadingScreen('fsLogin', 'Logging in'));
		firebase.auth().sendPasswordResetEmail(email).then(user => {
			successCallback();
			dispatch(addModalWindow(infoModal("modal_reset_password_instruction")))
		}).catch(error => {
			console.log(error);

			const errorMessage = getAuthErrorMessage(error.code);

			if(!errorMessage){
				debugger;
				dispatch(sendError(error, CRASH_ERROR, 'error_resetting_password'));
				errorCallback()
			} else {
				errorCallback(errorMessage)
			}

			debugger;
			// throw new Error("Nie zalogowano")
			// dispatch(addModalWindow('Nie zalogowano'));
		})

	}
}


/**
 * Funkcja używana tylko przy rejestracji użytkownika mailem
 * @param email
 * @param password
 * @param errorCallback - służy do wyświetlenia błędu na ekranie rejestracji
 * @param successCallback
 */
export function fsCreateAndMergeUserEmail(email, password, errorCallback, successCallback) {
	return (dispatch, getState) => {
		const credential = firebase.auth.EmailAuthProvider.credential(email, password);
		firebase.auth().useDeviceLanguage();

		return firebase.auth().currentUser.linkAndRetrieveDataWithCredential(credential).then((user) => {
			successCallback();
			console.log('zalogowany');

			if(user.user){
				user = user.user;
			}

			dispatch(initializeUserState(user));
			dispatch(fsUpdateIsAnonymousUserFlag());

			let name = user.displayName || user.email || "User";
			if(name === user.email){
				name = name.replace(/(@.+)/g, "")
			}
			let avatar = user.photoURL || undefined;

			dispatch(updateUserName(name));
			dispatch(updateUserAvatar(avatar));
			dispatch(fsUpdateUserNameAndAvatar(name, avatar));
			dispatch(setIsAnonymousUserFlag(false));

			dispatch(addToast('toast_login_welcome_user', 5000, [name]))

		}).catch(error => {
			console.log(error);

			const errorMessage = getAuthErrorMessage(error.code);

			if(!errorMessage){
				debugger;
				dispatch(sendError(error, CRASH_ERROR, 'error_creating_user'));
				errorCallback()
			} else {
				errorCallback(errorMessage)
			}

			debugger;
			// throw new Error("Nie zalogowano")
			// dispatch(addModalWindow('Nie zalogowano'));
		})
	}
}

/**
 * Funkcja używana na ekranie logowania,
 * Merge użytkownika polega na:
 * Przed naciśnięciem guzika logowania socialnego, zapisujemy w localstorage uid anonimowego użytkownika
 * Po przekierowaniu dostajemy puste zwrotki z bazy (Użytkownik nie jest zainicjowny).
 * W tym wypadku sprawdzamy czy w localstorage jest uid, jeśli tak to mergujemy przy użyciu mergeAndDeleteAnonymousUser
 * W innym wypadku wołamy fixUserDatabase
 *
 * @param type:
 * FS_LOGIN_FACEBOOK
 * FS_LOGIN_GOOGLE
 */
export function fsLoginUserSocial(type){
	return (dispatch, getState) => {
		let provider;
		if(type === FS_LOGIN_FACEBOOK){
			provider = new firebase.auth.FacebookAuthProvider();
		} else {
			provider = new firebase.auth.GoogleAuthProvider();
		}

		/**
		 * Zapisujemy uid żeby po przekierowaniu wiedzieć z którego użytkownika skopiować
		 */
		const oldUid = getState().userReducer.uid;
		debugger;

		localStorage.setItem('oldUid', oldUid);

		firebase.auth().useDeviceLanguage();

		return firebase.auth().signInWithRedirect(provider).then((result) => {

		}).catch(error => {
			console.log(error);
			debugger;
			// throw new Error("Nie zalogowano")
			dispatch(sendError(error, CRASH_ERROR, 'error_could_not_log_in'));
		})
	}

}


/**
 * Funkcja jest wywoływana przy pierwszym otwarciu aplikacji, lub wylogowaniu
 */
export function fsLoginUserAnonymously() {
	return dispatch => {
		dispatch(addLoadingScreen('loading_logging_in'));
		firebase.auth().useDeviceLanguage();
		return firebase.auth().signInAnonymously().then((user) => {
			console.log('zalogowany');

			let uid;
			if(user.user){
				uid = user.user.uid
			} else {
				uid = user.uid
			}

			dispatch(initializeUserCloudFunction(false));
			dispatch(loginUser(uid))
		})
			.catch(error => {
				console.log(error);
				debugger;
				// throw new Error("Nie zalogowano")
				dispatch(sendError(error, CRASH_ERROR, 'error_could_not_log_in'));
			})
			.then(() => {
				dispatch(removeLoadingScreen('loading_logging_in'));
			});
	}
}

/**
 * Funkcja wywoływana po pomyślym zalogowaniu
 * @param uid
 * @param isAnonymous - jest to pole z obiektu Auth, używamy do porównania czy zgadza się z tym z bazy
 */
export function fetchUserInfo(uid, isAnonymous) {
	return dispatch => {
		dispatch(addLoadingScreen('loading_user_info', [PLAY_SCREEN, EXTRA_SCREEN]));
		return fsVersion.collection("users").doc(uid)
			.get()
			.then(doc => {
				const userInfo = doc.data()

				if(userInfo && Object.keys(userInfo).length > 0){
					dispatch(saveUserInfoAndSettings(userInfo));

					if(userInfo.isAnonymous !== isAnonymous){
						dispatch(fsUpdateIsAnonymousUserFlag())
					}
				} else {
					const oldUid = localStorage.getItem('oldUid');

					if(oldUid){
						dispatch(mergeAndDeleteAnonymousUser(oldUid))
					} else {
						dispatch(fixUserDatabase())
					}
				}
			})
			.catch(error => {
				console.log(error);
				debugger;
				dispatch(sendError(error, CRASH_ERROR, 'error_could_not_get_user_info', JSON.stringify({uid, isAnonymous})));

			})
			.then(() => {
				dispatch(removeLoadingScreen('loading_user_info'));
			});
	}
}

export function fetchUserStats(uid, isAnonymous) {
	return dispatch => {
		dispatch(addLoadingScreen('loading_user_stats', [SETTINGS_SCREEN, PLAY_SCREEN, EXTRA_SCREEN]));
		return fsVersion.collection("rankings").doc(uid)
			.get()
			.then(doc => {
				const userStats =  doc.data();

				if(userStats && Object.keys(userStats).length > 0) {
					dispatch(saveUserRanking(userStats));
					dispatch(setActivePlayerStats(userStats))

					if(userStats.isAnonymous !== isAnonymous){
						dispatch(fsUpdateIsAnonymousUserFlag())
					}
				} else {
					const oldUid = localStorage.getItem('oldUid');

					if(oldUid){
						dispatch(mergeAndDeleteAnonymousUser(oldUid))
					} else {
						dispatch(fixUserDatabase())
					}
				}
			})
			.catch(error => {
				console.log(error);
				debugger;
				dispatch(sendError(error, CRASH_ERROR, 'error_could_not_get_user_stats', JSON.stringify({uid})));

			})
			.then(() => {
				dispatch(removeLoadingScreen('loading_user_stats'));
			});
	}
}

export function saveSettings(settings){
	return (dispatch, getState) => {
		const state = getState()
		const uid = state.userReducer.uid;
		return fsVersion.collection("users").doc(uid)
			.update({settings})
			.catch(error => {
				console.log(error);
				debugger;
				dispatch(sendError(error, NON_FATAL_ERROR, 'error_could_not_save_settings', JSON.stringify({uid, settings})));
			})
			.then(() => {
				dispatch(settingsSaved())
			});
	}
}


export function fsUpdateUserNameAndAvatar(displayName, avatar) {
	return dispatch => {

		const updateUserAvatarOrName = functions.httpsCallable('updateUserAvatarOrName');

		return updateUserAvatarOrName({ displayName, avatar, CLOUD_FUNCTION_ROOT_COLLECTION, CLOUD_FUNCTION_ROOT_DOCUMENT })
			.then(result => {
				console.log('wynik', result.data);
				const { displayName, avatar } = result.data;

				debugger
				dispatch(updateUserName(displayName));
				dispatch(updateUserAvatar(avatar));
				return result.data
			})
			.catch(error => {
				console.log(error);
				debugger;

				const data = parseCloudFunctionErrorAndUnsetCode(error);

				dispatch(sendError(error, CRASH_CLOUD_FUNCTION_ERROR, 'error_could_not_update_display_name_and_avatar', data));
			});
	}
}

/**
 * Funckja wywoływana w momencie gdy isAnonymous z auth oraz z bazy są różne, oraz po merge mail
 */
export function fsUpdateIsAnonymousUserFlag(){
	return (dispatch, getState) => {
		const state = getState();
		const uid = state.userReducer.uid;

		const updateUserAnonymousFlag = functions.httpsCallable("updateUserAnonymousFlag");
		updateUserAnonymousFlag({ CLOUD_FUNCTION_ROOT_COLLECTION, CLOUD_FUNCTION_ROOT_DOCUMENT })
			.catch(error =>{
				dispatch(sendError(error, NON_FATAL_ERROR,
					'error_could_not_update_anonymous_flag',
					JSON.stringify({uid})));
			})

	}
}

/**
 * Funkcja uploadująca zdjęcie avatare do jego uid folderu w storage
 *
 * @param uid
 * @param file
 * @param fileExtension
 */
export function uploadImageToStorage(uid, file, fileExtension) {
	return (dispatch, getState) => {
		const storageRef = firebase.storage().ref();

		const fileName = `upload.${fileExtension}`;
        const path = uid + "/" + fileName;
        const uidRef = storageRef.child(path);

		return uidRef.put(file)
			.then(() => {
				return uploadAvatarCloudFunction(fileName);
			})
			.then(url => {
				//TODO dodaj query z timestamp
				dispatch(updateUserAvatar(url))
			})
			.catch(error => {
				if(isErrorFromCloudFunction(error)){
					const data = parseCloudFunctionErrorAndUnsetCode(error);

					dispatch(sendError(error, CRASH_CLOUD_FUNCTION_ERROR, 'error_uploading_avatar', data));
				} else {
					const state = getState();
					const uid = state.userReducer.uid;
					dispatch(sendError(error, CRASH_ERROR, 'error_uploading_avatar', JSON.stringify({uid})));
				}

				debugger;
			});
	}

}

/* Cloud function */

/**
 * Funckja która merguje usera po zalogowaniu się Socialami
 * Odpalana jest jeśli użytkownik ma pustą bazę
 *
 * ustawia flagę isFixingDatabase
 *
 * @param oldUid - uid anonimowego użytkownika które jest zapisywe do
 * local storage w momencie kliknięcia logowania socialnego
 * */
export function mergeAndDeleteAnonymousUser(oldUid) {

	return (dispatch, getState) => {
		const state = getState();
		// debugger;

		if(!state.userReducer.isFixingDatabase){
			console.log("merge wszedl");

			dispatch(setIsFixingDatabase(true));

			const mergeAndDeleteAnonymousUser = functions.httpsCallable("mergeAndDeleteAnonymousUser");
			// const oldUid = "nG3OaFpe2lbLykkhvlH5MU4JRPp2";

			dispatch(addLoadingScreen('loading_merging'));
			mergeAndDeleteAnonymousUser({
				oldUid,
				CLOUD_FUNCTION_ROOT_COLLECTION,
				CLOUD_FUNCTION_ROOT_DOCUMENT })
				.then(result => {
					const { rankings, user, userLevels, userRiddles } = result.data;

					dispatch(saveUserInfoAndSettings(user));
					dispatch(saveUserRanking(rankings));
					dispatch(setActivePlayerStats(rankings));

					const levelObject = transformLevelListToLevelGameTypeObject(userLevels);

					dispatch(saveAllUserLevels(levelObject));

					dispatch(saveAllUserRiddles(userRiddles));

					// userRiddles
					debugger
				})
				.catch(error => {
					debugger;

					if(isErrorFromCloudFunction(error)){
						const data = parseCloudFunctionErrorAndUnsetCode(error);

						dispatch(sendError(error, CRASH_CLOUD_FUNCTION_ERROR, 'error_could_not_merge_user', data));
					} else {
						const uid = state.userReducer.uid;
						dispatch(sendError(error, CRASH_ERROR, 'error_could_not_merge_user', JSON.stringify({uid, oldUid})));
					}


					dispatch(fixUserDatabase());
					// throw new Error('Odblokowywanie poziomu nie powiodlo się')

				})
				.then(() => {
					dispatch(setIsFixingDatabase(false));
					dispatch(removeLoadingScreen('loading_merging'));
					localStorage.removeItem("oldUid");
				})
		}
	}
}


/**
 * Funkcja wywoływana w przypadku jeśli zwrotka z bazy jest pusta.
 * Może być odpalona tylko jeśli już w trakcie działania, oraz baza danych nie jest resetowana
 *
 * ustawia flagę isFixingDatabase która chroni przed odpaleniem funkcji podwójnie lub mergem
 *
 * @returns {function(*, *)}
 */
export function fixUserDatabase() {
	return (dispatch, getState) => {
		const state = getState();
		if(!state.userReducer.isFixingDatabase && !state.gameReducer.isDatabaseResetting){
			// debugger;

			dispatch(setIsFixingDatabase(true));

			const fixUserDatabase = functions.httpsCallable('fixUserDatabase');
			dispatch(addLoadingScreen('loading_database_fixing'));

			const rankingLanguage = navigator.language || navigator.userLanguage || getTranslation("language");
			fixUserDatabase({
				userLanguage: getTranslation("language"),
				rankingLanguage,
				isAnonymous: state.userReducer.isAnonymous,
				CLOUD_FUNCTION_ROOT_COLLECTION,
				CLOUD_FUNCTION_ROOT_DOCUMENT })
				.then(defaultStats => {
					// debugger
					const { userInfo, userStats, level } = defaultStats.data;

					if(userInfo){
						dispatch(
							// saveUserInfoAndSettings(Object.assign({}, userInfo, {accountCreationDate: toDateFunction}))
							saveUserInfoAndSettings(userInfo)
						)
					}

					if(userStats){
						dispatch(saveUserRanking(userStats))
						dispatch(setActivePlayerStats(userStats));


					}

					if(level){
						for(let gameType in level){
							if(level.hasOwnProperty(gameType)){
								dispatch(saveGameTypeUserLevel(level[gameType], gameType))
							}
						}
					}

				})
				.catch(error => {
					console.log(error);
					debugger;

					if(isErrorFromCloudFunction(error)){
						const data = parseCloudFunctionErrorAndUnsetCode(error);

						dispatch(sendError(error, CRASH_CLOUD_FUNCTION_ERROR, 'error_database_fix', data));
					} else {
						const uid = state.userReducer.uid;
						dispatch(sendError(error, CRASH_ERROR, 'error_database_fix', JSON.stringify({uid})));
					}

					return false
				})
				.then(() => {
					dispatch(setIsFixingDatabase(false));
					dispatch(removeLoadingScreen('loading_database_fixing'));
				});
		}
	}
}


/**
 * Funkcja wywoływana jeśli użytkownik potwierdzi usunięcie konta w modalu
 * Równocześnie odpala cloud funkcję usuwania, oraz wylogowanie się z aplikacji
 */
export function deleteUserAndData(){
	return (dispatch, getState) => {
		const deleteUserAndData = functions.httpsCallable('deleteUserAndData');

		deleteUserAndData({ CLOUD_FUNCTION_ROOT_COLLECTION, CLOUD_FUNCTION_ROOT_DOCUMENT })
			.catch(error => {
				if(isErrorFromCloudFunction(error)){
					const data = parseCloudFunctionErrorAndUnsetCode(error);

					dispatch(sendError(error, CRASH_CLOUD_FUNCTION_ERROR, 'error_delete_user_and_data', data));
				} else {
					const state = getState();
					const uid = state.userReducer.uid;
					dispatch(sendError(error, CRASH_ERROR, 'error_delete_user_and_data', JSON.stringify({uid})));
				}

				debugger;
			});
		dispatch(setDidUserDeleteAccount(true));
		dispatch(fsLogoutUser());
	}
}

/**
 * Funkcja wywoływana gdy użytkownik zakręci kołem
 */
export function spinTheWheel(successCallback, failCallback) {
	return (dispatch, getState) => {

		const spinTheWheel = functions.httpsCallable('spinTheWheel');

		spinTheWheel({ CLOUD_FUNCTION_ROOT_COLLECTION, CLOUD_FUNCTION_ROOT_DOCUMENT })
			.then(result => {
				return result.data
			})
			.then(data => {
				dispatch(updateLastSpinOfWheel(data.lastSpinOfWheel));
				if(data.angle === undefined || data.multiplier === undefined){
					failCallback()
				} else {
					const { angle, multiplier } = data;

					dispatch(updateHintCount(multiplier, true));

					//Jeżeli modal otwarty
					const modalList = getState().screenReducer.modalList;
					if(modalList.length > 0 && modalList[0].type === TYPE_WHEEL){
						successCallback(angle, multiplier)
					} else {
						if(multiplier === 1){
							dispatch(addToast("modal_wheel_win_toast_text_singular"))
						} else {
							dispatch(addToast("modal_wheel_win_toast_text_plural", 5000, [multiplier]));
						}
					}
					//Inaczej pokaż toast
				}
			})
			.catch(error => {
				if(isErrorFromCloudFunction(error)){
					const data = parseCloudFunctionErrorAndUnsetCode(error);

					dispatch(sendError(error, CRASH_CLOUD_FUNCTION_ERROR, 'error_spin_the_wheel', data));
				} else {
					const state = getState();
					const uid = state.userReducer.uid;
					dispatch(sendError(error, CRASH_ERROR, 'error_spin_the_wheel', JSON.stringify({uid})));
				}

				debugger;
			});


	}
}

export function uploadAvatarCloudFunction(fileName) {
    const uploadAvatar = functions.httpsCallable('uploadAvatar');

	return uploadAvatar({ CLOUD_FUNCTION_ROOT_COLLECTION, CLOUD_FUNCTION_ROOT_DOCUMENT, fileName })
		.then(result => {
			return result.data
		})
}

/* Synchroniczne */
/**
 * funkcja która odpowiada za togglowanie dzwięku w grze,
 *
 * ustawia flagę didSettingsChange na true
 *
 * @param isSound - aktualny stan
 */
export function toggleSound(isSound){
	return {
		type: TOGGLE_SOUND,
		payload: isSound
	}
}

/**
 * funkcja która odpowiada za togglowanie wibracji w grze,
 *
 * ustawia flagę didSettingsChange na true
 *
 * @param isVibration - aktualny stan
 */
export function toggleVibration(isVibration){
	return {
		type: TOGGLE_VIBRATION,
		payload: isVibration
	}
}


/**
 * ustawia flagę didSettingsChange na false
 */
export function settingsSaved(){
	return {
		type: SETTINGS_SAVED
	}
}

/**TODO Będzie refactor żeby z bazy zaciągał
 * Funkcja podmienia statystyki w stanie na te przesłane parametrem
 *
 * @param userStats - Obiekt z statystykami użytkownika
 */
export function replaceUserStats(userStats){
	return {
		type: REPLACE_USER_STATS,
		payload: {
			userStats
		}
	}
}

/**
 * Funkcja wołana przy pomyślnym zalogowaniu użytkownika
 * @param uid
 */
function loginUser(uid){
	return {
		type: LOGIN_USER,
		payload: {
			uid
		}
	}
}

export function updateUserName(displayName){
	return {
		type: UPDATE_USER_NAME,
		payload: {
			displayName
		}
	}
}

export function updateUserAvatar(avatar) {
	return {
		type: UPDATE_USER_AVATAR,
		payload: {
			avatar
		}
	}
}

/**
 * Funkcja wołana po wylogowaniu użytkownika
 * Przywraca bazę danych do defaultowego stanu, z wyjątkiem didDeleteAccount, która służy do poprawnego wyświetlenia
 * toast po usunięciu konta
 */
export function resetUserAfterLogout(){
	return {
		type: RESET_USER_AFTER_LOGOUT
	}
}

/**
 * Zmienia aktualną akcję na ekranie logowania mailowego
 *
 * rodzaje akcji znajdują się w constants/LOGIN_EMAIL_ACTIONS.js
 * @param action:
 * LOGIN
 * REGISTER
 * RESET
 * @returns {{type: string, payload: *}}
 */
export function changeLoginAction(action){
	return {
		type: CHANGE_LOGIN_ACTION,
		payload: action
	}
}

/**
 * Funkcja wołana po otrzymaniu zwrotki dokumentu użytkownika
 * fetchUserInfo, mergeAndDeleteAnonymousUser, fixUserDatabase, resetUserDatabase
 * @param userInfo - pola dokumentu użytkownika
 */
export function saveUserInfoAndSettings(userInfo) {
	return {
		type: SAVE_USER_INFO_AND_SETTINGS,
		payload: {
			userInfo
		},
	};
}

/**
 * Funkcja wołana po otrzymaniu zwrotki z rankingu użytkownika
 * fetchUserStats, mergeAndDeleteAnonymousUser, fixUserDatabase, resetUserDatabase
 * @param userStats - pole dokumentu rankingu użytkownika
 * @returns {{type: string, payload: {userStats: *}}}
 */
export function saveUserRanking(userStats) {
	return {
		type: SAVE_USER_RANKING,
		payload: {
			userStats
		},
	};
}

/**
 * Funkcja wywoływana przy naprawie bazy danych i mergowaniu socialnym
 * mergeAndDeleteAnonymousUser, fixUserDatabase
 *
 * Służy jako zabezpieczenie przed powieleniem obu funkcji, powoduje że podczas działania jednych z tych funkcji
 * nie może być odpalona inna
 *
 * @param isFixingDatabase - boolean
 */
function setIsFixingDatabase(isFixingDatabase){
	return {
		type: SET_IS_FIXING_DATABASE,
		payload: {
			isFixingDatabase
		},
	}
}

/**
 * Funkcja wołana po zmiane autentykacji,
 * lub po mergowniu mailowym(tylko dlatego że merge nie powoduje zmiany autentykacji)
 *
 * @param isAnonymous - boolean
 */
export function setIsAnonymousUserFlag(isAnonymous){
	return {
		type: SET_IS_USER_ANONYMOUS_FLAG,
		payload: {
			isAnonymous
		},
	}
}

/**
 * Funkcja wołana po potwierdzeniu usunięcia konta, ustawia ona flage która jest sprawdzana po zmiane autentykacji
 * Pokazuje toast że pomyślnie usunięto konto
 *
 * @param didDeleteAccount - boolean
 */
export function setDidUserDeleteAccount(didDeleteAccount){
	return {
		type: SET_DID_USER_DELETE_ACCOUNT,
		payload: {
			didDeleteAccount
		},
	}
}

/**
 * Wywoływana przed uruchomieniem cloud funkcji w purchaseHint
 * @param amount - ilosc odjęta lub dodana do obecnego hintCount
 * @param isIncrease - czy dodajemy hinCount
 */
export function updateHintCount(amount, isIncrease) {
	return {
		type: UPDATE_HINT_COUNT,
		payload: {
			amount,
			isIncrease
		}
	}
}

/**
 * Wywoływana po zakręceniu kołem
 * @param lastSpinOfWheel - obecna data
 */
export function updateLastSpinOfWheel(lastSpinOfWheel) {
	return {
		type: UPDATE_LAST_SPIN_OF_WHEEL,
		payload: {
			lastSpinOfWheel
		}
	}
}

/* Helpers */

/**
 * Pomaga obsłużyć błędy wyrzucone poprzez firebase authentication
 * @param errorCode - kod który jest zwrócony przez firebase
 * @returns Date - obiekt błędu odpowiadający temu z firebase
 */
function getAuthErrorMessage(errorCode){
	switch(errorCode){
		case "auth/email-already-in-use":
			return authErrorBuilder("This email already has an account", "email");

		case "auth/invalid-email":
			return authErrorBuilder("Invalid email", "email");

		case "auth/weak-password":
			return authErrorBuilder("Password is too weak", "password");

		case "auth/user-disabled":
			return authErrorBuilder("Your account has been disabled", "email");

		case "auth/user-not-found":
			return authErrorBuilder("User doesn't exist", "email");

		case "auth/wrong-password":
			return authErrorBuilder("Incorrect password", "password");

		default:
			return false;

	}
}

/**
 * Funkcja jest pomocnikiem do parsowania daty zwróconej poprzez Cloud function,
 * Czasem zwracany jest int z milisekundami, a czasem timestamp z funkcją toDate
 * @param date - ms lub timestamp
 * @returns Date
 */
function getCorrectDateFromTimestamp(date){
	if(isNaN(date)){
		return date.toDate();
	} else {
		return new Date(date);
	}
}

function getWeek(date){
	const offset = 1;
	const newYear = new Date(date.getFullYear(), 0, 1);
	let day = newYear.getDay() - offset;
	day = (day >= 0 ? day : day + 7);
	const daynumber = Math.floor((date.getTime() - newYear.getTime() -
		(date.getTimezoneOffset()-newYear.getTimezoneOffset())*60000)/86400000) + 1;
	let weeknumber;
	if(day < 4) {
		weeknumber = Math.floor((daynumber+day-1)/7) + 1;
		if(weeknumber > 52) {
			let nYear = new Date(date.getFullYear() + 1,0,1);
			let nday = nYear.getDay() - offset;
			nday = nday >= 0 ? nday : nday + 7;
			weeknumber = nday < 4 ? 1 : 53;
		}
	}
	else {
		weeknumber = Math.floor((daynumber+day-1)/7);
	}
	return weeknumber;
}


const defaultState = {
	user: {

	},
	stats: {

	},
	settings: {

	},
	isFixingDatabase: false, //lock, pozwala na wykonywanie tylko 1 funkcji w tym samym czasie
	didSettingsChange: false, // flaga używana w celu zapisu do bazy po wyjściu z ekranu ustawień
	didDeleteAccount: false, // flaga potrzebna żeby pokazać stosowny toast po usunięciu konta
	uid: "",
	isAnonymous: null, //flaga brana z auth
	loginAction: LOGIN_EMAIL_ACTIONS.LOGIN //akcja która odpowiada za formularze w login-email-screen
};

export default function(state = defaultState, action) {
	try {
		switch (action.type) {
			case LOGIN_USER: {
				// const newUserObject = Object.assign({}, { user: action.payload });
				return Object.assign({}, {...state}, {...action.payload});
			}
			case UPDATE_USER_NAME: {
				const user = state.user;
				const newUser = Object.assign({}, user, { displayName: action.payload.displayName });

				const stats = state.stats;
				const newStats = Object.assign({}, stats, { displayName: action.payload.displayName });

				return Object.assign({}, {...state}, {user: newUser, stats: newStats});
			}
			case UPDATE_USER_AVATAR: {
				const user = state.user;
				let newAvatar = getImageWithoutCache(action.payload.avatar);

				const newUser = Object.assign({}, user, { avatar: newAvatar });

				const stats = state.stats;
				const newStats = Object.assign({}, stats, { avatar: newAvatar });

				return Object.assign({}, {...state}, {user: newUser, stats: newStats});
			}
			case SAVE_USER_INFO_AND_SETTINGS: {
				const { settings, ...userInfo } = action.payload.userInfo;

				const isAndroid = /(android)/i.test(navigator.userAgent);
				const newSettingsObject = Object.assign(
					{},
					{...state.user},
					{...settings},
					{ isVibrate: settings.isVibrate && isAndroid});

				delete userInfo['isAnonymous'];

				const accountCreationDate = getCorrectDateFromTimestamp(userInfo['accountCreationDate']);

				const lastSignInDate = getCorrectDateFromTimestamp(userInfo['lastSignInDate']);

				const lastSpinOfWheel = getCorrectDateFromTimestamp(userInfo['lastSpinOfWheel']);

				const newUserObject = Object.assign(
					{},
					{ ...state.user },
					{ ...userInfo },
					{
						accountCreationDate,
						lastSignInDate,
						lastSpinOfWheel,
						avatar: getImageWithoutCache(userInfo.avatar)
					},
				);

				return Object.assign({}, {...state}, {user: newUserObject, settings: newSettingsObject});
			}

			case SET_IS_USER_ANONYMOUS_FLAG:{
				return Object.assign({}, { ...state }, { isAnonymous: action.payload.isAnonymous });
			}

			case SET_DID_USER_DELETE_ACCOUNT:{
				return Object.assign({}, { ...state }, { didDeleteAccount: action.payload.didDeleteAccount });
			}

			case SAVE_USER_RANKING: {
				const { userStats } = action.payload;
				const lastCollectedDate = getCorrectDateFromTimestamp(userStats['lastCollectedDate']);

				const newStatsObject = Object.assign(
					{},
					{...userStats},
					{
						lastCollectedDate,
						avatar: getImageWithoutCache(userStats.avatar)
					});

				const returnState = Object.assign({}, {...state}, {stats: newStatsObject});

				return returnState;
			}
			case TOGGLE_SOUND:{
				const newSettingsObject = Object.assign({}, {...state.settings}, {isSound: action.payload});
				return Object.assign({}, {...state}, {settings: newSettingsObject, didSettingsChange: true});
			}
			case TOGGLE_VIBRATION:{
				const newSettingsObject = Object.assign({}, {...state.settings}, {isVibrate: action.payload});
				return Object.assign({}, {...state}, {settings: newSettingsObject, didSettingsChange: true});
			}
			case SETTINGS_SAVED:{
				return Object.assign({}, {...state}, { didSettingsChange: false });
			}

			case REPLACE_USER_STATS:{
				const stats = action.payload.userStats;
				if(stats.lastCollectedDate){
					stats.lastCollectedDate = new Date()
				}

				const newStatsObject = Object.assign({}, state.stats, stats);

				const returnState = Object.assign({}, {...state}, {stats: newStatsObject});

				// debugger;
				return returnState;
			}

			case RESET_USER_AFTER_LOGOUT:{
				return Object.assign({}, defaultState, {didDeleteAccount: state.didDeleteAccount});
			}

			case CHANGE_LOGIN_ACTION:{
				const returnState = Object.assign({}, {...state}, {loginAction: action.payload});
				return returnState;
			}

			case SET_IS_FIXING_DATABASE:{
				return Object.assign({}, {...state}, {isFixingDatabase: action.payload.isFixingDatabase});
			}

			case UPDATE_HINT_COUNT: {
				let hintCount = state.user.hintCount;
				let usedHintCount = state.user.usedHintCount;
				if(action.payload.isIncrease){
					hintCount = hintCount + action.payload.amount;
				} else {
					hintCount = hintCount - action.payload.amount;
					usedHintCount = usedHintCount + 1;
				}
				const user = Object.assign({}, { ...state.user }, { hintCount, usedHintCount });
				return Object.assign({}, { ...state }, { user })
			}

			case UPDATE_LAST_SPIN_OF_WHEEL: {
				let lastSpinOfWheel = getCorrectDateFromTimestamp(action.payload.lastSpinOfWheel);
				const user = Object.assign({}, { ...state.user }, { lastSpinOfWheel });
				return Object.assign({}, { ...state }, { user })
			}

			default:
				return state;
		}
	} catch(error){
		addReducerParametersToError(error, "error_user_reducer", action, state);
		throw error
	}
}
